import { render, staticRenderFns } from "./DisplayTable.vue?vue&type=template&id=08b7fa93&"
import script from "./DisplayTable.vue?vue&type=script&lang=js&"
export * from "./DisplayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports